import React from 'react'
import styled from '@emotion/styled'
import GeneralModal from '../generic/modals/GeneralModal'
import Button from '../generic/button'
import { FlexRowDiv } from '../generic/Basics'

import { BrowserUtils } from '../../utils/siteUtils'

export default ({ onClickPositive, onClickNegative, positiveCopyOverride, negativeCopyOverride, children, testId, ...props }) => {
  const isDesktop = BrowserUtils.isDesktop()
  return (
    <GeneralModal testId={testId} {...props}>
      {children}
      <FlexRowDiv>
        {onClickNegative && (
          <CondButtonSecondary data-testid={`${testId}-btn-cancel`} isDesktop={isDesktop} onClick={onClickNegative}>
            {negativeCopyOverride || 'Cancel'}
          </CondButtonSecondary>
        )}
        {onClickPositive && (
          <CondButtonPrimary data-testid={`${testId}-btn-ok`} id={'primaryButton'} isDesktop={isDesktop} onClick={onClickPositive}>
            {positiveCopyOverride || 'Continue'}
          </CondButtonPrimary>
        )}
      </FlexRowDiv>
    </GeneralModal>
  )
}

const CondButtonPrimary = styled(Button)`
  margin: 16px 8px 0px 8px;
  font-size: 16px;
  width: ${p => (p.isDesktop ? '35%' : '47%')};
  height: ${p => (p.isDesktop ? '70%' : '85%')};
  text-align: center;
  font-weight: 600;
  line-height: 1;
`

const CondButtonSecondary = styled(Button)`
  margin: 16px 8px 0px 8px;
  font-size: 16px;
  width: ${p => (p.isDesktop ? '35%' : '47%')};
  height: ${p => (p.isDesktop ? '70%' : '85%')};
  text-align: center;
  background-color: white;
  color: #0057b5;
  border-width: 2px;
  font-weight: 600;
  line-height: 1;
  &:hover {
    color: white;
  }
`
